export default class FormSender {
  static URL_SENDER = '/.netlify/functions/email-sender';
  static URL_UPLOADER = '/.netlify/functions/file-uploader';

  static formatHTML(__data) {
    let html = "";
    const keys = Object.keys(__data);
    keys.forEach((key, index) => {
      html = `${html}<b>${key}:</b> ${__data[key]}<br>`
    });

    return html;
  }

  // __data pot ser un objecte (1 email) o un array d'objectes (N emails).
  // L'array viatja com a JSON dins del camp "emails" i el backend els envia
  // un darrere l'altre (SendGrid no accepta bé dos enviaments instantanis).
  static async sendEmail(__data, __replyto) {
    return new Promise((resolve, reject) => {
      const emailSender = new XMLHttpRequest();
      emailSender.open('POST', this.URL_SENDER);
      emailSender.onload = () => {
        // Passem el COS de la resposta (JSON i text), no només l'status, perquè el caller
        // (defaultCb) pugui loguejar el missatge del server quan hi ha error.
        const text = emailSender.responseText || '';
        let json = null;
        try { json = JSON.parse(text); } catch (e) { /* la resposta no és JSON */ }
        const res = { status: emailSender.status, json, text };

        if (emailSender.status === 200) resolve(res);
        else reject(res);
      };
      emailSender.onerror = () => reject({ status: 0, json: null, text: 'Network error (sense resposta del server)' });

      const formData = new FormData();

      if (Array.isArray(__data)) {
        formData.append('emails', JSON.stringify(__data));
      } else {
        for (var key in __data) {
          formData.append(key, __data[key]);
        }
      }

      if (__replyto) {
        formData.append("replyTo", __replyto);
      }

      emailSender.send(formData);
    });
  }

  static async sendFile(__file, opts = {}) {
    const formName = opts.formName ? opts.formName : 'Contact';

    return new Promise((resolve, reject) => {
      const fileSender = new XMLHttpRequest();
      fileSender.open('POST', this.URL_UPLOADER);
      fileSender.onload = () => {
        if (fileSender.status === 200) {
          resolve(JSON.parse(fileSender.response));
        } else {
          reject(fileSender.response);
        }
      };

      const formData = new FormData();
      formData.append('form-name', formName);
      formData.append(__file.name, __file.value);

      fileSender.send(formData);
    });
  }
}
